import {
  CampaignType,
  SearchableCampaignSortableFields,
  SearchableSortDirection,
  SearchCampaignsQueryVariables
} from 'generated-graphql/graphql';
import { TabsValue } from '../constants/tabs';
import {
  CampaignStatus,
  SearchableCampaignSortInput
} from 'generated-graphql/types';

// Kept below the AppSync response size limit that searchCampaigns hits on large
// accounts; callers page through with `from` to load everything (PAD-5598).
export const CAMPAIGNS_PAGE_SIZE = 100;

const getFilterFromTabValue = (tabValue: TabsValue) => {
  switch (tabValue) {
    case TabsValue.RECRUITMENT:
      return {
        or: [
          {
            type: { eq: CampaignType.ApplicantOutreach }
          },
          {
            type: { eq: CampaignType.NewCandidateOutreach }
          },
          {
            type: { eq: CampaignType.HumanOutreach }
          }
        ]
      };
    case TabsValue.OTHER:
      return {
        type: { eq: CampaignType.EngagementOutreach }
      };
    default:
      return {};
  }
};

const getLiveStatusFilters = () => ({
  or: [
    {
      status: { eq: CampaignStatus.Live }
    },
    {
      status: { eq: CampaignStatus.FinishedSending }
    }
  ]
});

export const getDefaultCampaignsQueryVariables = ({
  organizationId,
  userId,
  search,
  tabValue,
  sort,
  showLiveOnly
}: {
  organizationId: string | undefined | null;
  userId?: string | undefined | null;
  search?: string;
  tabValue?: TabsValue;
  sort?: SearchableCampaignSortInput;
  showLiveOnly?: boolean;
}): SearchCampaignsQueryVariables => {
  return {
    filter: {
      ...(organizationId && { organizationId: { eq: organizationId } }),
      ...(userId && { userId: { eq: userId } }),
      ...(search && { title: { matchPhrase: search } }),
      ...(tabValue && getFilterFromTabValue(tabValue)),
      ...(showLiveOnly && getLiveStatusFilters()),
      not: {
        or: [
          {
            type: { eq: CampaignType.RequestCvOutreach }
          },
          {
            type: { eq: CampaignType.AtsJobApplicationUrlOutreach }
          }
        ],
        and: [
          {
            isParent: { eq: false }
          },
          {
            campaignGroupId: { exists: true }
          }
        ]
      }
    },
    sort: sort || {
      field: SearchableCampaignSortableFields.CreatedAt,
      direction: SearchableSortDirection.Desc
    },
    limit: 500
  };
};
